import { render, staticRenderFns } from "./MuwOrderDetail.vue?vue&type=template&id=b74301e6&scoped=true&"
import script from "./MuwOrderDetail.vue?vue&type=script&lang=js&"
export * from "./MuwOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./MuwOrderDetail.vue?vue&type=style&index=0&id=b74301e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74301e6",
  null
  
)

export default component.exports